module.exports = __webpack_public_path__ + "static/media/pin_semplicemente_vita_highlighted.a3957e80.png";